module.exports = __webpack_public_path__ + "img/9_industry_innovation_and_infrastructure_color.5bc49a11.svg";